// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__23iRi","messages":"Chat_messages__3ruvk","dateDivider":"Chat_dateDivider__3is8s"};